const resetOptionsInGroup = group => {
  return Object.keys(group || {}).reduce((accumulator, current) => ({
    ...accumulator,
    [current]: typeof group[current] === 'undefined' ? undefined : false
  }), {});
};
export default resetOptionsInGroup;